// extracted by mini-css-extract-plugin
export var addressFields = "_k8-0";
export var animationContainer = "_k8-1";
export var footer = "_k8-2";
export var lineItems = "_k8-3";
export var modalContent = "_k8-4";
export var orderName = "_k8-5";
export var strong = "_k8-6";
export var warning = "_k8-7";